const useClarity = () => {
    const env = import.meta.env.VITE_ENVIRONMENT;
    const clarityId = import.meta.env.VITE_CLARITY_ID ?? null;

    const isClarityEnv = env === "beta" || env === "prod";

    return { isClarityEnv, clarityId };
};

export { useClarity };

